import styled from 'styled-components';
import { pxToRem } from '../../assets/styles/helper';

export const IconWrapper = styled.div`
  margin-bottom: ${({ mb }) => (mb ? pxToRem(mb) : '0rem')};
  margin-right: ${({ mr }) => (mr ? pxToRem(mr) : '0rem')};
  margin-top: ${({ mt }) => (mt ? pxToRem(mt) : '0rem')};
  margin-left: ${({ ml }) => (ml ? pxToRem(ml) : '0rem')};
  cursor: ${({ tooltip }) => (tooltip ? 'pointer' : '')};
  
  &,
  svg {
    width: ${({ width }) => pxToRem(width) || pxToRem(12)}};;
    height: ${({ height }) => pxToRem(height) || pxToRem(12)}};
    fill: ${({ color }) => (color ? `${color}` : '')};
  }
`;
